import { Directive } from '@angular/core';

@Directive({
  selector: '[qpointInlineEditAddition]',
  standalone: true
})
export class QPointInlineEditAdditionDirective {
}
